module.exports = __webpack_public_path__ + "img/upload.39a6b411.svg";